/** @jsx jsx */

import { jsx } from '@balance-web/core';
import { Text } from '@balance-web/text';
import { forwardRefWithAs } from '@balance-web/utils';

type DescriptionProps = {
  /** The ID of the element. */
  id?: string;
};

export const FieldDescription = forwardRefWithAs<'div', DescriptionProps>(
  (props, ref) => {
    return <Text color="muted" size="small" ref={ref} {...props} />;
  }
);
